import styled from 'styled-components';
export const WrapperStyled = styled.div `
  display: flex;
  flex-direction: column;
  gap: 31px;
`;
export const GraphContentWrapperStyled = styled.div `
  height: ${({ size }) => size || '243px'};
  width: ${({ size }) => size || '243px'};
  position: relative;
  justify-content: center;
  align-items: center;
`;
export const LabelsContentWrapperStyled = styled.div `
  display: flex;
  gap: 12px 50px;
  flex-wrap: wrap;
  width: ${({ width }) => width || '243px'};
  justify-content: center;
  align-items: center;
`;
export const LabelContainerStyled = styled.div `
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
`;
export const LabelColorContainerStyled = styled.div `
  background-color: ${(props) => props.backgroundColor || '#FFFFFF'};
  width: 15px;
  height: 15px;
`;
export const InnerGraphInfoCircleStyled = styled.div `
  width: ${({ size }) => size || '120px'};
  height: ${({ size }) => size || '120px'};
  display: flex;
  flex-direction: column;
  z-index: 3;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #ebf5ff;
  box-shadow: 0px 0px 20px -2px rgba(0, 0, 0, 0.2);
  filter: drop-shadow(6px 6px 30px rgba(0, 118, 135, 0.1))
    drop-shadow(-4px -4px 13px rgba(255, 255, 255, 0.5))
    drop-shadow(4px 4px 10px rgba(0, 118, 135, 0.05));
`;
//# sourceMappingURL=styled.js.map